/*
** Polyfills for legacy browsers
*/
import 'custom-event-polyfill'
import 'picturefill'
import 'mdn-polyfills/Node.prototype.append'
import 'intersection-observer'
